var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:[
    'ep-checkbox__label',
    _vm.classes
  ]},[_c('v-row',{staticClass:"pa-0 ma-0"},[_c('input',{staticClass:"ep-checkbox__input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.modelValue},on:{"input":function($event){return _vm.$emit('update:model-value', $event.target.checked)}}}),_c('span',{staticClass:"ep-checkbox__checkmark"}),(_vm.label)?_c('p',{staticClass:"subtitle ma-0 pl-2"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }